import { getColumnDataType } from './getColumnDataType';
import { sortNumerically } from './sortNumerically';
import { sortAlphabetically } from './sortAlphabetically';
/**
 * Gets the sorter for the column based on the column definition if it is defined.
 * Otherwise, it checks the data type for the column and returns the sorter based on the data type
 * @param data
 * @param column
 */
export const getSorter = (data, column) => {
  if (column.sorter) return column.sorter;
  const columnDataType = getColumnDataType(data, column.dataIndex);
  return columnDataType === 'number' ? sortNumerically(column) : sortAlphabetically(column);
};